import { Injectable } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GpsTrackPointView } from 'src/app/data/model/gps-tracking-view';
import { DeviceApiService } from 'src/app/shared/api/services/device-api.service';
import { GpsTrackingApiService } from 'src/app/shared/api/services/gps-track-api.service';
import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { VehicleApiService } from 'src/app/shared/api/services/vehicle-api.service';
import { BaseEntityService } from 'src/app/shared/base/base-entity.service';
import {Icon, DomEvent, geoJSON, Map, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker, Layer, GridLayerOptions, latLngBounds, LatLngBounds, GridLayer, FeatureGroup } from 'leaflet';
import { BehaviorSubject, filter, map, Observable, tap, finalize } from 'rxjs';
import { PortalGroup } from 'src/app/data/model/portal-group';
import { Vehicle } from 'src/app/data/model/vehicle';
import { Device } from 'src/app/data/model/device';
import { NoGpsPointsDialogComponent } from 'src/app/features/map/components/no-gps-points.component';
import * as A from 'leaflet-marker-rotation';
import { ReaderDataApiService } from 'src/app/shared/api/services/reader-data-api.service';
import { DeviceEventApiService } from 'src/app/shared/api/services/device-event-api.service';
import { DeviceStatusLogApiService } from 'src/app/shared/api/services/device-status-log-api.service';
import { DeviceEvent } from 'src/app/data/model/device-event';
import { DevicesStates } from 'src/app/data/model/devices-states';
import { ReaderData } from 'src/app/data/model/reader-data';
import { GpsTrackingStartStopApiService } from 'src/app/shared/api/services/gps-track-start-stop-api.service';
import * as XLSX from '@e965/xlsx';
import { saveAs } from 'file-saver';
import { DeviceStatusMapApiService } from 'src/app/shared/api/services/device-status-map-api.service';
import { DeviceEventMapApiService } from 'src/app/shared/api/services/device-event-map-api.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class VehicleMapMarkersService extends BaseEntityService<
  GpsTrackPointView,
  GpsTrackingApiService
> {
  public map!:Map

  constructor(
    apiService: GpsTrackingApiService,
    private portalGroupService: PortalGroupApiService,
    private vehicleService: VehicleApiService,
    private deviceService: DeviceApiService,
    private readingService: ReaderDataApiService,
    private eventsService: DeviceEventMapApiService,
    private startStopService:GpsTrackingStartStopApiService,
    private statusService: DeviceStatusMapApiService,
    private dialog:MatDialog
  ) {
    super(apiService);
  }

  private groupsSubject = new BehaviorSubject<PortalGroup[] | null | null>(null);
  private vehiclesSubject = new BehaviorSubject<Vehicle[] | null | null>(null);
  private deviceSubject = new BehaviorSubject<Device[] | null | null>(null);
  private gpspointSubject = new BehaviorSubject<GpsTrackPointView[] | null | null>(null);
  private eventsSubject = new BehaviorSubject<DeviceEvent[] | null | null>(null);
  private statusSubject = new BehaviorSubject<DevicesStates[] | null | null>(null);
  private readingSubject = new BehaviorSubject<ReaderData[] | null | null>(null);
  public trackDate$ = new BehaviorSubject<Date | null | null>(null);
  public filterDate$ = new BehaviorSubject<String | null | null>(null);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  get observable_loading$() {
    return this.loadingSubject.asObservable();
  }

  get vehicles$(): Observable<Vehicle[] | null> {
    return this.vehiclesSubject.asObservable();
  }
  get groups$() {
    return this.groupsSubject.asObservable();
  }
  get devices$(): Observable<Device[] | null>{
    return this.deviceSubject.asObservable();
  }
  private openNoGpsPointsDialog(messege:string): void {
    this.dialog.open(NoGpsPointsDialogComponent, {
      width: '300px',
      data: { message: messege }//il mezzo selezionato non riporta nessun punto GPS
    });
  }

  loadGroup() {
    this.portalGroupService
      .getAll()
      .pipe(tap((res:any) => this.groupsSubject.next(res.results)))
      .subscribe();
  }


  loadPlates() { 
    this.vehicleService
      .getAll()
      .pipe(tap((res:any) => this.vehiclesSubject.next(res.results)))
      .subscribe((res:any)=>res.results);
  }

  loadDevices() {
    this.deviceService
      .getAll()
      .pipe(tap((res:any) => this.deviceSubject.next(res.results)))
  }


  setIcon(type:String){
    if (type === 'start') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/home.png'
          }
        })
    } else if (type === 'stop') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/finish_vehicle.png'
          }
        })
    } else {
      return Icon.extend({
        options:
          {
            iconSize: [24, 24], // size of the icon
            iconAnchor: [12, 12], // 12, 22 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],    
            iconUrl: '../../../../assets/images/nord.png'
          }
        })
    }
  }

  setStatusIcon(){
    return Icon.extend({
      options:
        {
          iconSize: [31, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/home.png'
        }
      })
  }

  setEventIcon(c:any){
    if (c.event_type_item?.description.toLowerCase() === 'alert 0') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/orginal_a.svg'
          }
        })
    } else if (c.event_type_item?.description.toLowerCase() === 'alert 1') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/special_a1.png'
          }
        })
    } else if (c.event_type_item?.description.toLowerCase() === 'alert 2') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/special_a2.png'
          }
        })
    } else if (c.event_type_item?.description.toLowerCase() === 'alert 3') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/special_a3.png'
          }
        })
    } else if (c.event_type_item?.description.toLowerCase() === 'alert 4') {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],  
            iconUrl: '../../../../assets/images/special4.png'
          }
        })
    } else {
      return Icon.extend({
        options:
          {
            iconSize: [31, 31], // size of the icon
            iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -51],   
            iconUrl: '../../../../assets/images/special_e.png'
          }
        })
    }
  }

  setReadingIcon(){
    return Icon.extend({
      options:
        {
          iconSize: [31, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/special_l.svg'
        }
      })
  }

  setRandomIcon(type:number){
    if (type === 1) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last1.png'
          }
        })
    } else if (type === 2) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last2.png'
          }
        })
    } else if (type === 3) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last3.png'
          }
        })
    } else if (type === 4) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last4.png'
          }
        })
    }else if (type === 5) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last5.png'
          }
        })
    }else if (type === 6) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last6.png'
          }
        })
    }else if (type === 7) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last7.png'
          }
        })
    }else if (type === 8) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last8.png'
          }
        })
    }else if (type === 9) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last9.png'
          }
        })
    }else if (type === 10) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last10.png'
          }
        })
    }else if (type === 11) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last11.png'
          }
        })
    }else if (type === 12) {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last12.png'
          }
        })
    }else {
      return Icon.extend({
        options:
          {
            iconSize: [this.map.getZoom()+20, this.map.getZoom()+20], // size of the icon
            iconAnchor: [this.map.getZoom() / 2, this.map.getZoom()],//[10, 24], // 8, 24 point of the icon which will correspond to marker's location
            popupAnchor: [0, -this.map.getZoom()], //[0, -51],  
            iconUrl: '../../../../assets/images/last12.png'
          }
        })
    }
  }

  setPopUpData(c:any, timestamp:string, speed:number):string{
    return`<div>
    <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Descrizione: ${c.licenseplate.brand ? c.licenseplate.brand : ''} ${c.licenseplate.model ? c.licenseplate.model : ''}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Gruppo: ${c.name}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>ID Veicolo: ${c.licenseplate.licenseplate}
        </td>
      </tr>
      <tr>
        <td>
          <b/>------------
        </td>
      </tr>
      <tr>
        <td>
          <b/>Data/Ora: ${timestamp}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Velocità: ${Math.round(speed)} Km/h
        </td>
      </tr>
    </table>
    </div>`;
  }

  setEventPopUpData(c:any, timestamp:string, speed:number, vehicle:Vehicle):string{
    return`<div>
    <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Evento: ${c.event_label}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Id Veicolo: ${vehicle.licenseplate}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Descrizione: ${vehicle.brand ? vehicle.brand : ''} ${vehicle.model ? vehicle.model : ''}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Dispositivo: ${c.device_item.serial_number ? c.device_item.serial_number : c.device_item.mac}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Gruppo: ${c.device_item?.group_item?.name}
        </td>
      </tr>
      <tr>
        <td>
          <b/>------------
        </td>
      </tr>
      <tr>
        <td>
          <b/>Data/Ora: ${timestamp}
        </td>
      </tr>
    </table>
    </div>`;
  }

  setStatusPopUpData(c:any, timestamp:string, speed:number, vehicle:Vehicle):string{
    return`<div>
    <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Stato Corrente: ${c.current_status_item?.description}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Dispositivo: ${c.device_item.serial_number ? c.device_item.serial_number : c.device_item.mac}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>ID Veicolo: ${vehicle.licenseplate}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Descrizione: ${vehicle.brand ? vehicle.brand : ''} ${vehicle.model ? vehicle.model : ''}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Gruppo: ${c.device_item?.group_item?.name}
        </td>
      </tr>
      <tr>
        <td>
          <b/>------------
        </td>
      </tr>
      <tr>
        <td>
          <b/>Data/Ora: ${timestamp}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Velocità: ${Math.round(speed)} Km/h
        </td>
      </tr>
    </table>
    </div>`;
  }

  setReadingPopUpData(c:any, timestamp:string, speed:number, vehicle:Vehicle):string{
    return`<div>
    <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Lettura: ${c.read}
        </td>
      </tr>
      <tr>
        <td>
          <b/>ID Veicolo: ${vehicle.licenseplate}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Descrizione: ${vehicle.brand ? vehicle.brand : ''} ${vehicle.model ? vehicle.model : ''}
        </td>
      </tr>
      <tr>
        <td>
          <b/>Dispositivo: ${c.device_item.serial_number ? c.device_item.serial_number : c.device_item.mac}
        </td>
      </tr>
      <tr style=\"background-color:#3f51b5; color:white\">
        <td>
          <b/>Gruppo: ${c.device_item?.group_item?.name}
        </td>
      </tr>
      <tr>
        <td>
          <b/>------------
        </td>
      </tr>
      <tr>
        <td>
          <b/>Data/Ora: ${timestamp}
        </td>
      </tr>
    </table>
    </div>`;
  }

  filterVehiclePoints(layer: L.FeatureGroup, id:number, start_date:Date, end_date:Date){
    layer.clearLayers();
    this.loadingSubject.next(true);
    this.trackDate$.next(null);
    var created_at:string=start_date+","+end_date
    this.filterDate$.next(created_at);
    this.apiService
      //.getFilteredGeoGPS(vehicle, created_at)
      .getGeoJsonFiltered(id, {created_at:created_at})
      .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          this.openNoGpsPointsDialog("Non ci sono punti GPS disponibili per il periodo selezionato.");
        }
        else {
          for (const c of res.results) {
            //this.trackDate$.next(new Date(c.gps_timestamp));
            var color:any;
            var r = Math.floor(Math.random() * (255+Math.random()));
            var g = Math.floor(Math.random() * (255+Math.random()));
            var b = Math.floor(Math.random() * (255+Math.random()));
            color= "rgb("+r+" ,"+g+","+ b+")"; 
            geoJSON(c.coords, {
              pointToLayer: (feature, latlng) => {
                let icon;
                let rotation = 0;
    
                
                icon = this.setIcon(feature.properties?.type);
                rotation = feature.properties?.angle || 0;

                var marker=new A.RotatedMarker(latlng, {
                  icon: new icon,
                  rotationAngle: rotation
                });

                if (feature.properties?.type==='start' || feature.properties?.type==='stop') {
                  marker.setZIndexOffset(200);
                }

                marker.bindPopup('Caricamento in corso....', { closeButton: false, pane: 'popups' });

                // 🔹 API call when popup opens
                marker.on('popupopen', () => {

                  // Optional: prevent multiple calls
                  if ((marker as any)._apiLoaded) return;
                  (marker as any)._apiLoaded = true;

                  

                  this.apiService
                    //.getFiltered(id, {last_lap: id})
                    .getWithFilter({id: feature.properties?.id})
                    .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
                    //.pipe(finalize(() => this.loadingSubject.next(false)))
                    .subscribe((res:any) => {
                      //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
                      for (const c of res.results) {
                        const timestamp = new Date(c.gps_timestamp).toLocaleString();
                        const speed = c.ground_speed * 3.6
                        const data:string=this.setPopUpData(c, timestamp, speed);
                        marker.setPopupContent(data);
                      }
                  });
                });
                return marker
              },
    
              onEachFeature: function (feature,layer:L.FeatureGroup) {
                if (feature.geometry.type !== 'Point' && feature.properties?.style){
                  const lineStyle = feature.properties.style
                  const style={
                    dashArray: lineStyle.dashArray,
                    color:lineStyle.color ||color,
                    weight:lineStyle.weight,
                    opacity:2
                  }
                  layer.setStyle(style)
                }
              }
            }).addTo(layer);
          }
        }
      });
  }

  vehicleStatusPoints(layer:L.FeatureGroup, id:number, ts:string | null, vehicle:Vehicle){
    const params: any = {
      data_collector: id,
      status_in:[10, 11, 12, 13]
    };
    const markerClusterGroup = new MarkerClusterGroup({clusterPane:'status', spiderfyOnMaxZoom: true, showCoverageOnHover: false});
    this.loadingSubject.next(true);
    if (ts?.includes(',')) {
      params.device_timestamp = ts;
    } else {
      params.date = ts;
    }
    this.statusService
      .getFiltered(id, params)
      .pipe(tap((res:any) => this.statusSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          this.openNoGpsPointsDialog("Non ci sono stati disponibili.");
        }
        //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
        let point;
        for (const c of res.results) {
          if(c.gps_point_item == null){
            continue;
          } else {
            const timestamp = new Date(c.gps_point_item.gps_timestamp).toLocaleString();
            const speed = c.gps_point_item.ground_speed * 3.6
            const coords = c.gps_point_item.coords.split(" ");
            const mark1= coords[1].split("(");
            const mark2= coords[2].split(")");
            if(mark1[1] < mark2[0]){
              point = new LatLng(mark2[0], mark1[1]);
            }else{
              point = new LatLng(mark1[1], mark2[0]);
            }
            //const point = new LatLng(mark2[0], mark1[1]);//(mark1[1], mark2[0]);
            const data:string=this.setStatusPopUpData(c, timestamp, speed, vehicle);
            const myicon=this.setStatusIcon()//this.setIcon('standard')
            var mk = marker(point,{icon: new myicon}).bindPopup(data, {closeButton: false, pane: 'popups'});
            mk.addTo(markerClusterGroup)
          }
        }
        markerClusterGroup.addTo(layer);
      });
  }

  vehicleReadingPoints(layer:L.FeatureGroup, id:number, ts:string | null, vehicle:Vehicle){
    const params: any = {
      data_collector: id
    };
    const markerClusterGroup = new MarkerClusterGroup({clusterPane:'readings', spiderfyOnMaxZoom: true, showCoverageOnHover: false});
    this.loadingSubject.next(true);
    if (ts?.includes(',')) {
      params.range_timestamp = ts;
    } else {
      params.date = ts;
    }
    this.readingService
      .getFiltered(id, params)
      .pipe(tap((res:any) => this.readingSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          this.openNoGpsPointsDialog("Letture non trovate.");
        }
        //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
        let point;
        for (const c of res.results) {
          if(c.gps_item == null){
            continue;
          } else {
            const timestamp = new Date(c.gps_item.gps_timestamp).toLocaleString();
            const speed = c.gps_item.ground_speed * 3.6
            const coords = c.gps_item.coords.split(" ");
            const mark1= coords[1].split("(");
            const mark2= coords[2].split(")");
            if(mark1[1] < mark2[0]){
              point = new LatLng(mark2[0], mark1[1]);
            }else{
              point = new LatLng(mark1[1], mark2[0]);
            }
            //const point = new LatLng(mark2[0], mark1[1]);//(mark1[1], mark2[0]);
            const data:string=this.setReadingPopUpData(c, timestamp, speed, vehicle);
            const myicon=this.setReadingIcon()//this.setIcon('standard')
            var mk = marker(point,{icon: new myicon}).bindPopup(data, {closeButton: false, pane: 'popups'});
            mk.addTo(markerClusterGroup)
          }
        }
        markerClusterGroup.addTo(layer);
      });
  }

  vehicleEventPoints(layer:L.FeatureGroup, id:number, ts:string | null, vehicle:Vehicle){
    const params: any = {
      event_type_in:[10, 11]
    };
    const markerClusterGroup = new MarkerClusterGroup({clusterPane:'events', spiderfyOnMaxZoom: true, showCoverageOnHover: false});
    this.loadingSubject.next(true);
    if (ts?.includes(',')) {
      params.device_timestamp = ts;
    } else {
      params.timestamp = ts;
    }
    this.loadingSubject.next(true);
    this.eventsService
      .getFiltered(id, params)
      .pipe(tap((res:any) => this.eventsSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          this.openNoGpsPointsDialog("Eventi non trovati.");
        }
        //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
        let point;
        for (const c of res.results) {
          if(c.gps_point_item == null){
            continue;
          } else {
            const timestamp = new Date(c.gps_point_item.gps_timestamp).toLocaleString();
            const speed = c.gps_point_item.ground_speed * 3.6
            const coords = c.gps_point_item.coords.split(" ");
            const mark1= coords[1].split("(");
            const mark2= coords[2].split(")");
            if(mark1[1] < mark2[0]){
              point = new LatLng(mark2[0], mark1[1]);
            }else{
              point = new LatLng(mark1[1], mark2[0]);
            }
            //const point = new LatLng(mark2[0], mark1[1]);//(mark1[1], mark2[0]);
            const data:string=this.setEventPopUpData(c, timestamp, speed, vehicle);
            const myicon=this.setEventIcon(c)//this.setIcon('standard')
            var mk = marker(point,{icon: new myicon}).bindPopup(data, {closeButton: false, pane: 'popups'});
            mk.setZIndexOffset(400);
            mk.addTo(markerClusterGroup);
          }
        }
        //markerClusterGroup.bringToFront();
        markerClusterGroup.addTo(layer);
      });
  }


  vehiclePoints( layer:L.FeatureGroup, id:number, vehicle:Vehicle) {
    this.loadingSubject.next(true);
    layer.clearLayers();
    this.apiService
      .getGeoJsonFiltered(id)
      .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe((res:any) => {
        if(res.results.length ===0){
          console.log("Nessun dato trovato");
          this.loadVehiclesLastPoint(layer, vehicle);
        }
        else {
          console.log("WRONG");
          for (const c of res.results) {
            this.trackDate$.next(new Date(c.gps_timestamp));
            var color:any;
            var r = Math.floor(Math.random() * (255+Math.random()));
            var g = Math.floor(Math.random() * (255+Math.random()));
            var b = Math.floor(Math.random() * (255+Math.random()));
            color= "rgb("+r+" ,"+g+","+ b+")"; 
            geoJSON(c.coords, {
              pointToLayer: (feature, latlng) => {
                let icon;
                let rotation = 0;
    
                
                icon = this.setIcon(feature.properties?.type);// sets icon type
                rotation = feature.properties?.angle || 0;

                var marker=new A.RotatedMarker(latlng, {
                  icon: new icon,
                  rotationAngle: rotation
                });

                if (feature.properties?.type==='start' || feature.properties?.type==='stop') {
                  marker.setZIndexOffset(200);
                }
                marker.bindPopup('Caricamento in corso....', { closeButton: false, pane: 'popups' });

                // 🔹 API call when popup opens
                marker.on('popupopen', () => {

                  // Optional: prevent multiple calls
                  if ((marker as any)._apiLoaded) return;
                  (marker as any)._apiLoaded = true;

                  this.apiService
                    //.getFiltered(id, {last_lap: id})
                    .getWithFilter({id: feature.properties?.id})
                    .pipe(tap((res:any) => this.gpspointSubject.next(res.results)))
                    //.pipe(finalize(() => this.loadingSubject.next(false)))
                    .subscribe((res:any) => {
                      //const data = res.results.filter((x:GpsTrackPointView)=>x.data_collector_id== id);
                      for (const c of res.results) {
                        const timestamp = new Date(c.gps_timestamp).toLocaleString();
                        const speed = c.ground_speed * 3.6
                        const data:string=this.setPopUpData(c, timestamp, speed);
                        marker.setPopupContent(data);
                      }
                  });
                });
                return marker
              },
    
              onEachFeature: function (feature,layer:L.FeatureGroup) {
                if (feature.geometry.type !== 'Point' && feature.properties?.style){
                  const lineStyle = feature.properties.style
                  const style={
                    dashArray: lineStyle.dashArray,
                    color:lineStyle.color ||color,
                    weight:lineStyle.weight,
                    opacity:2
                  }
                  layer.setStyle(style)
                }
              }
            }).addTo(layer);
          }
        }
      });
  }
  
  setMap(map:Map): void {
    this.map=map;
  }

  setMapData(data: Vehicle) {
    return{
      coords: data.coords,
      pop_up_data:`<div>
      <table style=\"width:100%; border-radius: 0px; font-size:15px;\">
        <tr style=\"background-color:#3f51b5; color:white\">
          <td>
            <b/>ID Veicolo: ${data.licenseplate}
          </td>
        </tr>
        <tr>
          <td>
            <b/> Descrizione: ${data.brand ? data.brand : ''} ${data.model ? data.model : ''}
          </td>
        </tr>
        <tr style=\"background-color:#3f51b5; color:white\">
          <td>
            <b/>Data Punto: ${moment(data.last_gps_update).format('DD/MM/yyyy, HH:mm:ss')}
          </td>
        </tr>
        <tr>
          <td>
            <b/>Gruppo: ${data.data_collector_item?.group_item?.name}
          </td>
        </tr>
      </table>
      </div>`
    } 
  }

  loadVehiclesLastPoint(markers: L.FeatureGroup, vehicle:Vehicle) {
    const data=this.setMapData(vehicle);
    if(!data.coords){
      this.openNoGpsPointsDialog("Non ci sono dati disponibili.");
    } else {
      var coord = String(data.coords).split(" ");
      const mark1= coord[1].split("(");
      const mark2= coord[2].split(")");
      const x=Number(mark2[0]) as number
      const y= Number(mark1[1]) as number
      if (x > y){
        var coords = new LatLng(x as number, y as number)
      } else {
        coords = new LatLng(y as number, x as number)
      }
      const myicon=this.setRandomIcon(Math.floor(Math.random() * 12) + 1)//this.setIcon('standard')
      var mk = marker(coords,{icon: new myicon}).bindPopup(data.pop_up_data, {closeButton: false, pane: 'popups'});
      mk.setZIndexOffset(400);
      mk.addTo(markers);
    }
  }
}